import BookingDetail from './BookingDetail.container';

export default BookingDetail;
